import styled from "styled-components";
import {
  device,
  colors,
  getTypographyFontStyle,
} from "../../styles/global.style";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 8%;
  margin: 100px 16px 60px;
  border-radius: 16px;
  background: rgba(19, 88, 150, 0.03);

  @media only screen and ${device.md} {
    margin: 120px 32px 80px;
    padding: 48px 8%;
  }

  @media only screen and ${device.lg} {
    margin: 120px auto 80px;
    max-width: 1200px;
    padding: 56px 10%;
  }
`;

export const Paragraph = styled.p`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
  color: ${(props) => props.color || colors.lightdark};
  margin: 1rem 0;
  max-width: 800px;
  line-height: 1.8;
  text-align: center;

  @media only screen and ${device.md} {
    text-align: left;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 40px 0;
  width: 100%;
  max-width: 800px;

  @media only screen and ${device.md} {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
`;

export const StatBox = styled.div`
  background: ${colors.white};
  padding: 24px 16px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(10, 22, 40, 0.06);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }

  .stat-number {
    font-family: "Space Grotesk", sans-serif;
    font-size: 28px;
    font-weight: 700;
    color: ${colors.primary};
    margin-bottom: 8px;

    @media only screen and ${device.md} {
      font-size: 32px;
    }
  }

  .stat-label {
    font-family: "Inter", sans-serif;
    font-size: 13px;
    color: ${colors.darkGrey};

    @media only screen and ${device.md} {
      font-size: 14px;
    }
  }
`;

export const MissionSection = styled.div`
  margin-top: 48px;
  padding: 40px 32px;
  background: linear-gradient(135deg, ${colors.secondary} 0%, ${colors.secondaryLight} 100%);
  border-radius: 16px;
  text-align: center;
  max-width: 800px;

  h2 {
    color: ${colors.white};
    margin-bottom: 16px;
  }

  p {
    color: ${colors.light};
    text-align: center;
    margin: 0;
  }
`;
